





























































































































import { Component, Vue } from "vue-property-decorator";

@Component
export default class Menu extends Vue {

  handleChangeLanguage() {
    if (this.$store.state.language === 'zh-CN') {
      this.$store.commit("changeLanguage");
      this.$router.push("/en");
    } else {
      this.$store.commit("changeLanguage");
      this.$router.push("/");
    }
    // window.location.reload();
  }
}

